module.exports = __webpack_public_path__ + "static/media/capitalpay.f20dbb57.svg";